
const inorderTraversalProblems = [
  {
   title: "Binary Tree Inorder Traversal",
   url: "https://leetcode.com/problems/binary-tree-inorder-traversal/"
  },
  {
    title: "Validate Binary Search Tree",
    url: "https://leetcode.com/problems/validate-binary-search-tree/"
  },
  {
    title: "Kth Smallest Element in a BST",
    url: "https://leetcode.com/problems/kth-smallest-element-in-a-bst/"
  },
  {
    title: "Binary Search Tree Iterator",
    url: "https://leetcode.com/problems/binary-search-tree-iterator/"
  },
  {
    title: "Recover Binary Search Tree",
    url: "https://leetcode.com/problems/recover-binary-search-tree/"
  }
];
export default inorderTraversalProblems;